// extracted by mini-css-extract-plugin
export var clickThrough = "_xn-2";
export var fallback = "_xn-5";
export var frame = "_xn-3";
export var frameCell = "_xn-1";
export var overlay = "_xn-4";
export var wrapper = "_xn-0";